export default class HealthPlanList {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "/policy/review";
  }

  listHealthPlans() {
    return this.client.get(`${this.resourceUrl}/healthplan/client?`);
  }

  fetchHealthPlan(hp) {
    return this.client.get(`/healthplan/${hp}`);
  }
}
